<div class="col-4 col-offset-4 new-player">
      <form (ngSubmit)="onSubmit()">
        <div class="form-group">
            <label for="activationcode" [innerHTML]="'auth.labels.form.activationcode' | translate"></label>
            <input
                    id="activationcode"
                    [(ngModel)]="activationCode.code"
                    class="form-control activation-field"
                    name="activation_code"
                    placeholder="{{'auth.labels.form.activationcode' | translate}}"
                    type="text"
            >
            <span *ngIf="error.message.text" class="form-validation error">
                {{ error.message.text | translate }}
            </span>
        </div>

        <div class="form-group">
            <div class="servicelinks">
                <a class="btn-txt"
                   (click)="onCancel()"
                   [innerHTML]="'general.buttons.cancel' | translate"
                ></a>
            </div>
            <button class="btn-default float-right"
                    type="submit"
            >
                <span [innerHTML]="'auth.buttons.register' | translate"></span>
            </button>
        </div>
    </form>
</div>
